import React from "react";
import Text from "@/components/ui/text";
import { cn } from "@/utils/utils";

interface IntegrationsSectionProps {
  title?: string;
  count?: number;
  children: React.ReactNode;
  className?: string;
  "data-test"?: string;
}

const IntegrationsSection: React.FC<IntegrationsSectionProps> = ({
  title,
  count,
  children,
  className,
  "data-test": dataTest
}) => (
  <section
    className={cn("flex w-full flex-col", className)}
    data-test={dataTest}
  >
    {title && (
      <div className="flex items-center gap-4">
        <Text as="h2" variant="lgBody" className="font-medium text-h2">
          {title}
        </Text>
        {count !== undefined && (
          <Text
            variant="smBody"
            className="flex min-w-5 items-center justify-center rounded-[6px] border-[0.5px] border-border-badge-chip-default bg-white-6 px-[2px] py-[1px]"
            data-test={`${dataTest}-count`}
          >
            {count}
          </Text>
        )}
      </div>
    )}
    <div className="grid grid-cols-3 auto-rows-[minmax(210px,auto)] gap-4">{children}</div>
  </section>
);

export default IntegrationsSection;
